import { Grid } from '@mui/material';
import { LuTag } from 'react-icons/lu';
import { WsChip, WsChipVariants, WsTypography, WsTypoVariants } from 'wisestep-base';
export const EmailSubject = ({
  emailsubject = '',
  emailType = 'Campaign Email',
}: {
  emailsubject: string;
  emailType?: string;
}) => (
  <Grid item display="flex" direction="column" rowGap={1}>
    <WsTypography variant={WsTypoVariants.TITLE} bold>
      {emailsubject}
    </WsTypography>
    <WsChip
      value={emailType}
      variant={WsChipVariants.UNKNOWN}
      icon={<LuTag fontSize={16} color="#000000" />}
    />
  </Grid>
);
